import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Panel } from 'primeng/panel';
import { TranslatePipe } from '@ngx-translate/core';
import { RecentCustomer } from '../../../../models/RecentCustomer';
import { RecentCustomerService } from '../../../../services/recent-customer.service';

/**
 * Home view "recently handled patients" dropdown. Open by default every
 * time it is (re)created, i.e. every time the user reaches or reloads the
 * Home view - there is no persisted open/closed state.
 */
@Component({
  selector: 'app-recent-customers',
  templateUrl: './recent-customers.component.html',
  styleUrls: ['./recent-customers.component.scss'],
  imports: [Panel, TranslatePipe]
})
export class RecentCustomersComponent implements OnInit {
  public customers: Array<RecentCustomer> = [];

  constructor(
    private router: Router,
    private recentCustomerService: RecentCustomerService
  ) {}

  ngOnInit(): void {
    this.recentCustomerService.getRecentCustomers().subscribe((customers) => {
      this.customers = customers;
    });
  }

  open(customer: RecentCustomer): void {
    if (customer.customerType === 'e') {
      this.router.navigate(['donor/external', customer.id]);
    } else if (customer.customerType === 'd') {
      this.router.navigate(['donor/basic', customer.id]);
    } else {
      this.router.navigate(['customer/basic', customer.id]);
    }
  }
}
